import { useTranslation } from "react-i18next";
import { useActivity } from "./useActivity";
import { PageContent, PageHeader } from "shared/components";
import { Box, Flex } from "styled-system/jsx";
import { AntennaSignal } from "iconoir-react";
import { Tag, Text } from "@ttc3k/trekker";
import { formatDate, getMultilingualString } from "shared/utils";
import { EnumOwnerType } from "gql/generated";

export const Activity = () => {
  const { t } = useTranslation();
  const { changelog, error, loading } = useActivity();

  return (
    <Flex flexDir={"column"} gap={"400"}>
      <PageHeader
        title={t("directory:OPERATOR.ACTIVITY.TITLE")}
        description={t("directory:OPERATOR.ACTIVITY.DESCRIPTION")}
        Icon={AntennaSignal}
      />
      <PageContent
        loading={loading}
        showSimpleError={!changelog}
        throwAppError={
          error && (error as unknown as { message: string })?.message
        }
      >
        <Box>
          {changelog?.map((item) => (
            <Flex
              key={item._id}
              flexDir="row"
              justifyContent="space-between"
              alignItems="center"
              gap="250"
              py="150"
              borderTopColor="border.light"
              borderTopWidth="1"
            >
              <Flex flexDir="row" alignItems="center" gap="100">
                <Tag
                  visual={
                    item.owner.type === EnumOwnerType.Organization
                      ? "warning"
                      : "accent.blue"
                  }
                  mode="light"
                >
                  @{item.initiatedByUser?.firstName}
                </Tag>
                <Text color="text.mid" visual="smallMedium">
                  {getMultilingualString(item.message)}
                </Text>
              </Flex>
              <Text color="text.light" visual="smallMedium">
                {formatDate(item.createdDateISO)}
              </Text>
            </Flex>
          ))}
        </Box>
      </PageContent>
    </Flex>
  );
};
